import React from "react";
import Header from "./header/Header";
import Footer from "./footer/Footer";
import { Outlet } from "react-router-dom";
import GTMPageView from "../../GTMPageView";
const MainLayout = () => {
  return (
    <>
      <Header />
      <main>
        <GTMPageView />
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default MainLayout;
